const ActionTypes = {
  ADD_CATEGORIES: 'ADD_CATEGORIES',
  ADD_CATEGORY: 'ADD_CATEGORY',
  RENAME_CATEGORY: 'RENAME_CATEGORY',
  DELETE_CATEGORY: 'DELETE_CATEGORY',
  SET_LAST_USED_CATEGORY: 'SET_LAST_USED_CATEGORY',
  UPDATE_CATEGORY_COUNT: 'UPDATE_CATEGORY_COUNT',
};

module.exports = {
  ActionTypes,
};
